import { render, staticRenderFns } from "./PayrollDetailsModel.vue?vue&type=template&id=2e93f60c&scoped=true&"
import script from "./PayrollDetailsModel.vue?vue&type=script&lang=js&"
export * from "./PayrollDetailsModel.vue?vue&type=script&lang=js&"
import style0 from "./PayrollDetailsModel.vue?vue&type=style&index=0&id=2e93f60c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93f60c",
  null
  
)

export default component.exports